import './list.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import Table from './components/table';
import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content approved-reject-list">
			<div className="container__content-title">
				<div className="container__content-title-position">
					<h1 className="title">{props.intl('Approved Rejected Payouts')}</h1>
				</div>
			</div>
			<div className="container__content-body">
				<div className="approved-reject-list__create">
					{ props.can('approvedRejectPayoutsEdit') && (
						<Link
							to="approve-reject/create/"
							className="ui-btn ui-btn-primary ui-btn-sign__plus"
						>
							{props.intl('Add new approved-reject payout')}
						</Link>
					) }
				</div>
				<Table {...props} />
			</div>
		</div>
	</Animate>
), 'approvedRejectPayoutsList');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		payoutCurrencies: selectors.getPayoutCurrencies(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/approve-reject/list.js